export const systemConstants = {
    CORRELATION_KEY: 'SSO_APP',
    CSRF_COOKIE_NAME: "idp_csrf-token"
};